<!-- @format -->
<ng-container *transloco="let t">
  @if (universitySettings$ | async; as universitySettings) {
    @if (universitySettings?.frontendFeatureToggles?.newPlanTabEnabled) {
      @if (userSettings$ | async; as settings) {
        <fudis-body-text [class]="'fudis-mb-md fudis-mt-md'">
          <fudis-icon [icon]="'info-circle-fill'" />
          {{ t("STUDY_STRUCTURE.NEW_STUDY_STRUCTURE_AVAILABLE") }}
        </fudis-body-text>
        <sis-toggle
          [autofocus]="planStateService.versionChanged"
          [label]="t('STUDY_STRUCTURE.NEW_STUDY_STRUCTURE_TOGGLE')"
          [checked]="settings.isNewPlanVersionInUse"
          (checkedChange)="toggle(settings, $event)" />
        @if (settings.isNewPlanVersionInUse) {
          <fudis-notification [variant]="'warning'" [class]="'fudis-mb-lg'">
            <fudis-body-text>
              {{ t("STUDY_STRUCTURE.NEW_STUDY_STRUCTURE_IN_USE") }}
            </fudis-body-text>
          </fudis-notification>
          @if (showSurvey) {
            <fudis-notification [variant]="'info'" [class]="'fudis-mb-lg'">
              <fudis-body-text>
                {{ t("STUDY_STRUCTURE.SURVEY.INFO") }}
                <a
                  fudisLink
                  [href]="'https://www.funilab.fi/login'"
                  [title]="t('STUDY_STRUCTURE.SURVEY.FUNILAB_LINK_TEXT')"
                  [external]="true"
                  [size]="'md'"></a>
                {{ t("STUDY_STRUCTURE.SURVEY.COMMUNITY_INFO") }}
                <a
                  fudisLink
                  [href]="'https://digitalist.leanlab.co/cgi/view?sid=20b01d167963a06a'"
                  [title]="t('STUDY_STRUCTURE.SURVEY.FUNILAB_JOIN_LINK_TEXT')"
                  [external]="true"
                  [size]="'md'"></a>
              </fudis-body-text>
            </fudis-notification>
          }
        }
      }
    }
  }
</ng-container>
